import { useState } from 'react'
import { UserPlus } from 'lucide-react'

import { ProductInviteDialog } from '@/components/invite/product-invite-dialog'
import {
  getProductInviteConfig,
  shouldShowProductInviteHeaderButton,
} from '@/constants/product-invite'
import { cn } from '@/lib/utils'

interface ProductInviteHeaderButtonProps {
  isAuthenticated: boolean
  /** Header chrome icon button styling from App.tsx. */
  iconButtonClassName?: string
  /** Header chrome labeled button styling from App.tsx. */
  labeledButtonClassName?: string
  /** CTA emphasis (white pill on primary header, surface chip otherwise). From App.tsx. */
  emphasisClassName?: string
  showLabel?: boolean
}

export function ProductInviteHeaderButton({
  isAuthenticated,
  iconButtonClassName,
  labeledButtonClassName,
  emphasisClassName,
  showLabel = true,
}: ProductInviteHeaderButtonProps) {
  const [dialogOpen, setDialogOpen] = useState(false)
  const config = getProductInviteConfig()

  if (
    !config ||
    !shouldShowProductInviteHeaderButton({ isAuthenticated })
  ) {
    return null
  }

  const buttonClassName = showLabel ? labeledButtonClassName : iconButtonClassName

  return (
    <>
      <button
        type="button"
        onClick={() => setDialogOpen(true)}
        className={cn(buttonClassName, emphasisClassName)}
        title={config.ctaButtonLabel}
        aria-label={config.headline}
      >
        <UserPlus className="h-4 w-4 shrink-0" aria-hidden />
        {showLabel ? <span>{config.ctaButtonLabel}</span> : null}
      </button>
      <ProductInviteDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        headline={config.headline}
        description={config.blurb}
        submitLabel={config.ctaButtonLabel}
      />
    </>
  )
}
